import axios from 'axios';
import { useState, useEffect } from 'react';

const SupplierList = () => {
    const [suppliers, setSuppliers] = useState([]);

    useEffect(() => {
        const fetchSuppliers = async () => {
            try {
                // API-Anfrage an das Backend
                const response = await axios.get("https://api-invoice.foodchainflow.de/api/suppliers");
                setSuppliers(response.data);
            } catch (error) {
                console.error("Fehler beim Laden der Lieferanten:", error);
            }
        };

        fetchSuppliers();
    }, []);

    return (
        <div>
            <h2>Lieferanten</h2>
            <table>
                <thead>
                <tr>
                    <th>Name</th>
                    <th>Adresse</th>
                    <th>Telefon</th>
                    <th>Email</th>
                    <th>IBAN</th>
                </tr>
                </thead>
                <tbody>
                {suppliers.map((supplier) => (
                    <tr key={supplier.id}>
                        <td>{supplier.name}</td>
                        <td>{supplier.address}</td>
                        <td>{supplier.phone}</td>
                        <td>{supplier.email}</td>
                        <td>{supplier.iban}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default SupplierList;
